export const CHANGE_CURRENT_PAGE = 'awsSettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'awsSettings/CHANGE_PAGE_SIZE'
export const CREATE_AWS_SETTING = 'awsSettings/CREATE_AWS_SETTING'
export const FETCH_AWS_SETTINGS_LIST = 'awsSettings/FETCH_AWS_SETTINGS_LIST'
export const FETCH_AWS_SETTINGS_FOR_OPTIONS = 'awsSettings/FETCH_AWS_SETTINGS_FOR_OPTIONS'
export const REMOVE_AWS_SETTING = 'awsSettings/REMOVE_AWS_SETTING'
export const UPDATE_AWS_SETTING = 'awsSettings/UPDATE_AWS_SETTING'
